<div class="ai-feedback" role="group" aria-label="Évaluer cette réponse">
  <button
    type="button"
    class="ai-feedback__vote"
    [class.ai-feedback__vote--on]="current() === 'up'"
    [attr.aria-pressed]="current() === 'up'"
    [disabled]="sending()"
    aria-label="Bonne réponse"
    (click)="up()"
  >
    <i class="pi" [class.pi-thumbs-up-fill]="current() === 'up'" [class.pi-thumbs-up]="current() !== 'up'"></i>
  </button>
  <button
    type="button"
    class="ai-feedback__vote"
    [class.ai-feedback__vote--on]="current() === 'down'"
    [attr.aria-pressed]="current() === 'down'"
    [disabled]="sending()"
    aria-label="Mauvaise réponse"
    (click)="down()"
  >
    <i class="pi" [class.pi-thumbs-down-fill]="current() === 'down'" [class.pi-thumbs-down]="current() !== 'down'"></i>
  </button>
  @if (thanks() && !panelOpen()) {
    <span class="ai-feedback__thanks" role="status">Merci, c'est transmis à l'équipe EVA IT.</span>
  }
</div>

@if (panelOpen()) {
  <div class="ai-feedback__panel">
    <strong>Qu'est-ce qui ne va pas ?</strong>
    <div class="ai-feedback__reasons">
      @for (r of reasons; track r.value) {
        <button
          type="button"
          class="ai-feedback__chip"
          [class.ai-feedback__chip--on]="reason === r.value"
          [attr.aria-pressed]="reason === r.value"
          (click)="pick(r.value)"
        >
          {{ r.label }}
        </button>
      }
    </div>
    <eva-textarea
      label="Précisez si vous voulez (facultatif)"
      [(ngModel)]="comment"
      [maxlength]="maxLength"
      [rows]="3"
    />
    <p class="ai-feedback__consent">
      Cet échange (votre question, la réponse et les actions de l'assistant) sera transmis à l'équipe EVA IT pour
      corriger l'assistant.
    </p>
    <div class="ai-feedback__buttons">
      <eva-button label="Envoyer" severity="primary" [loading]="sending()" (onClick)="send()" />
    </div>
  </div>
}
